export class ConfigurationViewModel {
    IdConfiguration: number;
    Key: string;
    Value: string;
    Description: string;
}
